import React from "react";
import { Star } from "@phosphor-icons/react";
import { useLang } from "@/context/LangContext";

export const RatingStars = ({ value = 0, size = 14, onChange, className = "" }) => (
  <span className={`inline-flex items-center gap-0.5 ${className}`}>
    {[1, 2, 3, 4, 5].map((n) => {
      const filled = n <= Math.round(value);
      const star = (
        <Star size={size} weight={filled ? "fill" : "regular"} color={filled ? "#e8c56a" : "rgba(233,233,237,0.35)"} />
      );
      return onChange ? (
        <button key={n} type="button" data-testid={`star-${n}`} onClick={() => onChange(n)} className="p-0.5">
          {star}
        </button>
      ) : (
        <span key={n}>{star}</span>
      );
    })}
  </span>
);

export const RatingBadge = ({ avg, count, className = "" }) => {
  const { t } = useLang();
  if (!count) return null;
  return (
    <span className={`inline-flex items-center gap-1 text-[12px] text-ppc-text ${className}`} data-testid="rating-badge">
      <Star size={13} weight="fill" color="#e8c56a" />
      {Number(avg).toFixed(1)}
      <span className="text-ppc-muted">({count} {t("rev_reviews")})</span>
    </span>
  );
};
